module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_1216_angora.581c3960.jpg";